var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDashboardWidgets = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30771",
    "data-name": "Group 30771",
    transform: "translate(-1880 -129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_charts",
    transform: "translate(1880 129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infographic",
    transform: "translate(2.6 2)",
    fill: "#00aabe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48656",
    "data-name": "Path 48656",
    d: "M2.771,9.4A.745.745,0,0,1,2.2,9.125.878.878,0,0,1,2.259,7.95L5.73,4.622a.731.731,0,0,1,.6-.2l6,.784,3.4-3.475a.732.732,0,0,1,1.09.032A.879.879,0,0,1,16.8,2.937L13.134,6.68a.739.739,0,0,1-.623.222L6.494,6.115,3.283,9.194a.737.737,0,0,1-.512.21Z",
    transform: "translate(-.336 -.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48657",
    "data-name": "Path 48657",
    d: "M20.536,5.16a.621.621,0,0,1-.441-.183L17.183,2.065A.624.624,0,0,1,17.624,1h2.912a.624.624,0,0,1,.624.624V4.536a.624.624,0,0,1-.624.624Z",
    transform: "translate(-4.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48658",
    "data-name": "Path 48658",
    d: "M5.991,18.04v2.288H1V18.04A1.04,1.04,0,0,1,2.04,17H4.952A1.04,1.04,0,0,1,5.991,18.04Z",
    transform: "translate(-.168 -3.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48659",
    "data-name": "Path 48659",
    d: "M13.991,12.04v7.279H9V12.04A1.04,1.04,0,0,1,10.04,11h2.912A1.04,1.04,0,0,1,13.991,12.04Z",
    transform: "translate(-2.104 -2.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48660",
    "data-name": "Path 48660",
    d: "M21.991,14.04v5.615H17V14.04A1.04,1.04,0,0,1,18.04,13h2.912A1.04,1.04,0,0,1,21.991,14.04Z",
    transform: "translate(-4.041 -3.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48661",
    "data-name": "Path 48661",
    d: "M18.2,23.748H.587a.625.625,0,0,1,0-1.248H18.2a.625.625,0,0,1,0,1.248Z",
    transform: "translate(0 -4.748)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDashboardWidgets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_dashboard_widgets.113d0f6fb948d2870c1f6c0beac0717f.svg";